import React, { memo, useEffect, useRef} from 'react';
import Utils from '../../utils/utils';

interface TurnstileProps{
    siteKey:string,
    onVerify:any
}

const Turnstile = memo(({ siteKey, onVerify }:TurnstileProps) => {
  const turnstileRef = useRef(null);

  useEffect(() => {
    // Wait for Turnstile script to load

    const loadTurnstile = () => {
      if (window?.turnstile ) {
        window.turnstile.render(turnstileRef.current, {
          sitekey: siteKey,
          callback: (token: any) => {
            console.log("token",token);
            
         localStorage.setItem("turnstileToken",token)
          },
        });
      } else {
        // Retry after a delay if script not loaded yet
        setTimeout(loadTurnstile, 100);
      }
    };

    loadTurnstile();

    // Cleanup: optionally reset widget on unmount
    return () => {
      if (window.turnstile && turnstileRef.current ) {
        window.turnstile.reset(turnstileRef.current);
      }
    };

  }, [siteKey, onVerify]);

  return <div ref={turnstileRef}></div>;
});

export default Turnstile;